import { useEffect, useRef } from 'react';

import { useFastshiftAnalyticsData, useFireAnalyticsEvents } from '@/analytics';
import { SourceKey, ActionKey, ActionSubjectKey, ActionSubjectIdKey } from '@/analytics/constants';
import { useFastshiftSelector } from '@/state';

import { buildDomainWideForYouPageDetailsAttributes } from './utils';

export const useDashboardPageAnalytics = () => {
	const { data: customerDomain } = useFastshiftSelector((state) => state.customerDomain);
	const { data: supportRequests, pending: supportRequestsPending } = useFastshiftSelector(
		(state) => state.supportRequests,
	);

	const { identityAttrs } = useFastshiftAnalyticsData();
	const { fireScreenEvent, fireTrackEvent } = useFireAnalyticsEvents(identityAttrs);

	const lastFiredKeyRef = useRef<string | null>(null);

	// Screen event
	useEffect(() => {
		if (!identityAttrs) return;
		fireScreenEvent({
			name: SourceKey.FASTSHIFT_PORTAL_FOR_YOU_SCREEN,
		});
	}, [fireScreenEvent, identityAttrs]);

	// Track event - when the dashboard data required by the active experience is loaded
	useEffect(() => {
		if (!customerDomain || !identityAttrs || !supportRequests || supportRequestsPending) return;

		const attrs = buildDomainWideForYouPageDetailsAttributes(supportRequests);
		if (!attrs) return;

		const key = JSON.stringify({
			...identityAttrs,
			...attrs,
		});

		if (lastFiredKeyRef.current === key) {
			return;
		}

		fireTrackEvent({
			action: ActionKey.DISPLAYED,
			actionSubject: ActionSubjectKey.SECTION,
			actionSubjectId: ActionSubjectIdKey.FOR_YOU_PAGE_DETAILS,
			source: SourceKey.FASTSHIFT_PORTAL_FOR_YOU_SCREEN,
			attributes: attrs,
		});
		lastFiredKeyRef.current = key;
	}, [customerDomain, supportRequests, supportRequestsPending, identityAttrs, fireTrackEvent]);
};
